import { TItemType } from '@types';
import { formatNumber } from './formatNumber';

/** An Item type's maximum size as it reads in a table: "180 × 40 × 40 cm", length by width by height. */
export const formatItemTypeDimensions = (itemType: Pick<TItemType, 'max_length_cm' | 'max_width_cm' | 'max_height_cm'>) => {
	const { max_length_cm, max_width_cm, max_height_cm } = itemType;
	return `${formatNumber(max_length_cm)} × ${formatNumber(max_width_cm)} × ${formatNumber(max_height_cm)} cm`;
}
